import {
  type AssetModalRightPanelOpenTab,
  type AssetModalRightPanelsTab,
} from '~/components/AssetModalV2/assetModalRightPanelTabs';
import { parseAssetModalRightPanelTabFromRouterAsPath } from '~/components/AssetModalV2/utils/parseAssetModalRightPanelTabFromRouterAsPath';

export type AssetModalRightPanelTabFromRouterUrl = {
  activeRightPanelTab: AssetModalRightPanelsTab;
  lastActiveTab: AssetModalRightPanelOpenTab | undefined;
};

type GetAssetModalRightPanelTabForRouterUrlParams = {
  currentTab: AssetModalRightPanelsTab;
  routerUrl: string;
};

/**
 * Maps a completed route URL onto panel state. Missing `am-tab` is Info unless the panel is
 * already closed (`none`) — close is local UI state and must not reopen on unrelated navigations.
 */
export const getAssetModalRightPanelTabForRouterUrl = ({
  currentTab,
  routerUrl,
}: GetAssetModalRightPanelTabForRouterUrlParams): AssetModalRightPanelTabFromRouterUrl => {
  const tabFromUrl = parseAssetModalRightPanelTabFromRouterAsPath(routerUrl);

  if (tabFromUrl) {
    return { activeRightPanelTab: tabFromUrl, lastActiveTab: tabFromUrl };
  }

  if (currentTab === 'none') {
    return { activeRightPanelTab: 'none', lastActiveTab: undefined };
  }

  return { activeRightPanelTab: 'info', lastActiveTab: 'info' };
};
